module.exports = __webpack_public_path__ + "static/media/COS_OCP_PHOENIX.11027542.png";